import { render } from "./fangDetail.vue?vue&type=template&id=7a5e7561&scoped=true"
import script from "./fangDetail.vue?vue&type=script&lang=js"
export * from "./fangDetail.vue?vue&type=script&lang=js"

import "./fangDetail.vue?vue&type=style&index=0&id=7a5e7561&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a5e7561"

export default script